import { IGetItemVerbaFuncionarioDropDownUseCase } from "../../../presentation/useCases/read/get_item_verba_funcionario_drop_down_use_case";
import { ItemVerbaFuncionarioDropDown } from "../../models/item_verba_funcionario_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllItemVerbaFuncionarioDropDownUseCase
 */

export class GetItemVerbaFuncionarioDropDownUseCase implements IGetItemVerbaFuncionarioDropDownUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getAllItemVerbaFuncionarioDropDown(
    idFuncionario: number,
  ): Promise<ItemVerbaFuncionarioDropDown[]> {
    return await this.repository.getItemVerbaFuncionarioDropDown(idFuncionario);
  }
}
